export { ProgressBarComponent, type ProgressBarModel } from './progress-bar.component';
